import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'EuclidCircularA', sans-serif`,
    body: `'EuclidCircularA', sans-serif`,
  },
});

export default theme;